import { AcceptedFileSize } from '../interfaces/accepted-file-size.interface';
import { MAX_IMAGE_SIZE, MAX_IMAGE_SIZE_UNITS } from '../constants/general-constants';

export function checkFileSize(size: number, maxFileSize?: { value: number; unit: string }): AcceptedFileSize {
    let index = 0;
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    while (size >= 1024 && ++index) {
        size = size / 1024;
    }

    let finalMaxSize = MAX_IMAGE_SIZE;
    let finalMaxSizeUnits = MAX_IMAGE_SIZE_UNITS;

    if (maxFileSize) {
        finalMaxSize = maxFileSize.value;
        finalMaxSizeUnits = maxFileSize.unit;
    }

    const convertedSize = Number(size.toFixed(2));
    const maxUnitIndex = units.indexOf(finalMaxSizeUnits.toUpperCase());
    // const acceptedFileSize = !(maxUnitIndex <= index && convertedSize >= finalMaxSize);
    const acceptedFileSize = index < maxUnitIndex || (index === maxUnitIndex && convertedSize <= finalMaxSize);

    return {
        acceptedFileSize: acceptedFileSize,
        fileSize: units[index],
    } as AcceptedFileSize;
}
